import React from 'react';
import UISidebar2 from './UISidebar2';

const UIScript = ({ selectedTab, onTabChange, pageClassName = '', enableClicking = false, scriptContent }) => {
  // Default script content for Home.js
  const defaultScriptContent = (
    <>
      <div className="script-action">Michael’s question is left unanswered as their whirlwind of a brother crashes the party. JACK, mid 30’s, handsome and dressed in an expensive suit.</div>
      <div className="script-character">JACK</div>
      <div className="script-dialogue">Sorry I'm late. I was with a client.</div>
      <div className="script-action">He kisses the top of Cara’s head and high-fives Michael, before taking a seat.</div>
      <div className="script-character">CARA</div>
      <div className="script-dialogue">You were with a client or were you the client?</div>
      <div className="script-action">Jack folds a napkin in his lap and claps back:</div>
      <div className="script-character">JACK</div>
      <div className="script-dialogue">Good one. Hey -- how’s your marriage?</div>
      <div className="script-character">CARA</div>
      <div className="script-parenthetical">(fakes a smile)</div>
      <div className="script-dialogue">Great. Never been better.</div>
      <div className="script-action">Jack grabs an olive and leans back in the chair.</div>
      <div className="script-character">JACk</div>
      <div className="script-parenthetical">(talks with his mouth full)</div>
      <div className="script-dialogue">So -- how does the old man plan to divide his fundings?</div>
      <div className="script-action">He spots a waiter and waves him over.</div>
      <div className="script-character">JACK</div>
      <div className="script-dialogue">Can we get a bottle of Louis Roederer? Thank you.</div>
      <div className="script-character">CARA</div>
      <div className="script-dialogue">Champagne?</div>
      <div className="script-action">Jack nods and wipes his hands together in excitement. He’s ready to listen.</div>
      <div className="script-character">CARA</div>
      <div className="script-dialogue">We're going over dad's will and you’re ordering champagne?</div>
    </>
  );

  return (
    <div className={pageClassName}>
      <div className="flex gap-8 ui-clickable-wrapper ui-ideate">
        <UISidebar2 selectedTab={selectedTab} onTabChange={onTabChange} enableClicking={enableClicking} />
        <div className="ui-page">
          <div className="ui-page-content script-page-container">
            <div className="fake-script script-page-ui">
              {scriptContent || defaultScriptContent}
            </div>
          </div>
        </div>
        <div className="flex flex-column space-between">
          <div className="ui-script-panel top-panel">
            <div className="flex flex-column gap-8">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="4.5" cy="10" r="1.5" fill="black"/>
                <circle cx="10" cy="10" r="1.5" fill="black"/>
                <circle cx="15.5" cy="10" r="1.5" fill="black"/>
              </svg>
              <div className="panel-divider"></div>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.5 7.33C3.5 5.62153 3.5 4.76729 3.83776 4.11708C4.12239 3.56915 4.56915 3.12239 5.11708 2.83776C5.76729 2.5 6.62153 2.5 8.33 2.5H11.67C13.3785 2.5 14.2327 2.5 14.8829 2.83776C15.4309 3.12239 15.8776 3.56915 16.1622 4.11708C16.5 4.76729 16.5 5.62153 16.5 7.33V12.67C16.5 14.3785 16.5 15.2327 16.1622 15.8829C15.8776 16.4309 15.4309 16.8776 14.8829 17.1622C14.2327 17.5 13.3785 17.5 11.67 17.5H8.33C6.62153 17.5 5.76729 17.5 5.11708 17.1622C4.56915 16.8776 4.12239 16.4309 3.83776 15.8829C3.5 15.2327 3.5 14.3785 3.5 12.67V7.33Z" stroke="#272729" strokeWidth="1.25"/>
                <path d="M9 11.5H11" stroke="#272729" strokeWidth="1.25" strokeLinecap="round"/>
                <path d="M7.50012 8.5H12.5001" stroke="#272729" strokeWidth="2" strokeLinecap="round"/>
              </svg>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.5 7.33C3.5 5.62153 3.5 4.76729 3.83776 4.11708C4.12239 3.56915 4.56915 3.12239 5.11708 2.83776C5.76729 2.5 6.62153 2.5 8.33 2.5H11.67C13.3785 2.5 14.2327 2.5 14.8829 2.83776C15.4309 3.12239 15.8776 3.56915 16.1622 4.11708C16.5 4.76729 16.5 5.62153 16.5 7.33V12.67C16.5 14.3785 16.5 15.2327 16.1622 15.8829C15.8776 16.4309 15.4309 16.8776 14.8829 17.1622C14.2327 17.5 13.3785 17.5 11.67 17.5H8.33C6.62153 17.5 5.76729 17.5 5.11708 17.1622C4.56915 16.8776 4.12239 16.4309 3.83776 15.8829C3.5 15.2327 3.5 14.3785 3.5 12.67V7.33Z" stroke="#272729" strokeWidth="1.25"/>
                <path d="M6.99988 11.5H12.9999" stroke="#272729" strokeWidth="1.25" strokeLinecap="round"/>
                <path d="M7.50012 9.5H12.5001" stroke="#272729" strokeWidth="1.25" strokeLinecap="round"/>
                <path d="M9 13.5H11" stroke="#272729" strokeWidth="1.25" strokeLinecap="round"/>
                <path d="M6.49988 7H13.4999" stroke="#272729" strokeWidth="1.25" strokeLinecap="round"/>
              </svg>
              <div className="panel-divider"></div>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M9.99485 2.66666L16.9231 6.66666L9.99485 10.6667L3.06665 6.66666L9.99485 2.66666Z" stroke="#272729" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M14.0395 8.33514L16.9231 9.99998L9.99485 14L3.06665 9.99998L5.95023 8.33514" stroke="#272729" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M14.0369 11.667L16.9231 13.3333L9.99485 17.3333L3.06665 13.3333L5.95286 11.667" stroke="#272729" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.87492 8.4375H6.27075C5.16618 8.4375 4.27075 9.33293 4.27075 10.4375V15.8125C4.27075 16.9171 5.16618 17.8125 6.27075 17.8125H13.7291C14.8337 17.8125 15.7291 16.9171 15.7291 15.8125V10.4375C15.7291 9.33293 14.8337 8.4375 13.7291 8.4375H13.1249" stroke="#272729" strokeWidth="1.25" strokeLinecap="round"/>
                <path d="M10 11.5625V2.1875M10 2.1875L6.875 5.3125M10 2.1875L13.125 5.3125" stroke="#272729" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </div>
          <div className="flex flex-column gap-8">
            <div className="ui-script-panel mid-panel">
              <div className="flex flex-column gap-8">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10 4.25V15.75" stroke="#272729" strokeWidth="1.25" strokeLinecap="round"/>
                  <path d="M4.25 10L15.75 10" stroke="#272729" strokeWidth="1.25" strokeLinecap="round"/>
                </svg>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4 10L15.5 10" stroke="#272729" strokeWidth="1.25" strokeLinecap="round"/>
                </svg>
              </div>
            </div>
            <div className="ui-script-panel bottom-panel">
              <div className="flex">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="2.75" y="2.75" width="14.5" height="14.5" rx="3" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M12.8 7L9.80005 10L12.8 13" stroke="black" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M6.5 17.25V2.75C4.42893 2.75 2.75 4.42893 2.75 6.5V13.5C2.75 15.5711 4.42893 17.25 6.5 17.25Z" fill="black"/>
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UIScript;
